import { CapacityLevels, EquipmentTypes } from './mc-map-enum';
import { IDatiqMapMetric } from './mc-map.models';

const datiqMcColors: { [key in CapacityLevels]: string } = {
    [CapacityLevels.VeryLoose]: '#1053C7',
    [CapacityLevels.ModeratelyLoose]: '#4AA6D2',
    [CapacityLevels.SlightlyLoose]: '#ADE6D0',
    [CapacityLevels.Neutral]: '#FFF6AD',
    [CapacityLevels.SlightlyTight]: '#FFCCA8',
    [CapacityLevels.ModeratelyTight]: '#F78B5E',
    [CapacityLevels.VeryTight]: '#C60B1F',
    [CapacityLevels.NoData]: '#f6f7f9',
    [CapacityLevels.NoArea]: '#f6f7f9',
    [CapacityLevels.CurrentlyUnavailable]: '#f6f7f9',
    [CapacityLevels.Empty]: '#f6f7f9',
};

const ltColorMapFlatbed: IDatiqMapMetric = {
    id: 'mci-map-flatbed',
    label: 'LT - Flatbeds',
    range: { high: Infinity, low: 0 },
    styles: [
        {
            color: datiqMcColors[CapacityLevels.VeryLoose],
            label: {
                text: CapacityLevels.VeryLoose,
            },
            range: {
                low: 0,
                high: 3.8,
            },
            index: 0,
        },
        {
            color: datiqMcColors[CapacityLevels.ModeratelyLoose],
            label: {
                text: CapacityLevels.ModeratelyLoose,
            },
            range: {
                low: 3.8,
                high: 8.8,
            },
            index: 1,
        },
        {
            color: datiqMcColors[CapacityLevels.SlightlyLoose],
            label: {
                text: CapacityLevels.SlightlyLoose,
            },
            range: {
                low: 8.8,
                high: 18.0,
            },
            index: 2,
        },
        {
            color: datiqMcColors[CapacityLevels.Neutral],
            label: {
                text: CapacityLevels.Neutral,
            },
            range: {
                low: 18.0,
                high: 24.0,
            },
            index: 3,
        },
        {
            color: datiqMcColors[CapacityLevels.SlightlyTight],
            label: {
                text: CapacityLevels.SlightlyTight,
            },
            range: {
                low: 24.0,
                high: 33.2,
            },
            index: 4,
        },
        {
            color: datiqMcColors[CapacityLevels.ModeratelyTight],
            label: {
                text: CapacityLevels.ModeratelyTight,
            },
            range: {
                low: 33.2,
                high: 42.2,
            },
            index: 5,
        },
        {
            color: datiqMcColors[CapacityLevels.VeryTight],
            label: {
                text: CapacityLevels.VeryTight,
            },
            range: {
                low: 42.2,
                high: Infinity,
            },
            index: 6,
        },
    ],
};

const ltColorMapVan: IDatiqMapMetric = {
    id: 'mci-map-van',
    label: 'LT - Vans',
    range: { high: Infinity, low: 0 },
    styles: [
        {
            color: datiqMcColors[CapacityLevels.VeryLoose],
            label: {
                text: CapacityLevels.VeryLoose,
            },
            range: {
                low: 0,
                high: 1.1,
            },
            index: 0,
        },
        {
            color: datiqMcColors[CapacityLevels.ModeratelyLoose],
            label: {
                text: CapacityLevels.ModeratelyLoose,
            },
            range: {
                low: 1.1,
                high: 2.2,
            },
            index: 1,
        },
        {
            color: datiqMcColors[CapacityLevels.SlightlyLoose],
            label: {
                text: CapacityLevels.SlightlyLoose,
            },
            range: {
                low: 2.2,
                high: 3.4,
            },
            index: 2,
        },
        {
            color: datiqMcColors[CapacityLevels.Neutral],
            label: {
                text: CapacityLevels.Neutral,
            },
            range: {
                low: 3.4,
                high: 6.9,
            },
            index: 3,
        },
        {
            color: datiqMcColors[CapacityLevels.SlightlyTight],
            label: {
                text: CapacityLevels.SlightlyTight,
            },
            range: {
                low: 6.9,
                high: 10.2,
            },
            index: 4,
        },
        {
            color: datiqMcColors[CapacityLevels.ModeratelyTight],
            label: {
                text: CapacityLevels.ModeratelyTight,
            },
            range: {
                low: 10.2,
                high: 15.1,
            },
            index: 5,
        },
        {
            color: datiqMcColors[CapacityLevels.VeryTight],
            label: {
                text: CapacityLevels.VeryTight,
            },
            range: {
                low: 15.1,
                high: Infinity,
            },
            index: 6,
        },
    ],
};

const ltColorMapReefer: IDatiqMapMetric = {
    id: 'mci-map-reefer',
    label: 'LT - Reefers',
    range: { high: Infinity, low: 0 },
    styles: [
        {
            color: datiqMcColors[CapacityLevels.VeryLoose],
            label: {
                text: CapacityLevels.VeryLoose,
            },
            range: {
                low: 0,
                high: 2.3,
            },
            index: 0,
        },
        {
            color: datiqMcColors[CapacityLevels.ModeratelyLoose],
            label: {
                text: CapacityLevels.ModeratelyLoose,
            },
            range: {
                low: 2.3,
                high: 4.8,
            },
            index: 1,
        },
        {
            color: datiqMcColors[CapacityLevels.SlightlyLoose],
            label: {
                text: CapacityLevels.SlightlyLoose,
            },
            range: {
                low: 4.8,
                high: 7.2,
            },
            index: 2,
        },
        {
            color: datiqMcColors[CapacityLevels.Neutral],
            label: {
                text: CapacityLevels.Neutral,
            },
            range: {
                low: 7.2,
                high: 13.7,
            },
            index: 3,
        },
        {
            color: datiqMcColors[CapacityLevels.SlightlyTight],
            label: {
                text: CapacityLevels.SlightlyTight,
            },
            range: {
                low: 13.7,
                high: 19.4,
            },
            index: 4,
        },
        {
            color: datiqMcColors[CapacityLevels.ModeratelyTight],
            label: {
                text: CapacityLevels.ModeratelyTight,
            },
            range: {
                low: 19.4,
                high: 28.3,
            },
            index: 5,
        },
        {
            color: datiqMcColors[CapacityLevels.VeryTight],
            label: {
                text: CapacityLevels.VeryTight,
            },
            range: {
                low: 28.3,
                high: Infinity,
            },
            index: 6,
        },
    ],
};


export const ltColorMaps: {
    [key: string]: IDatiqMapMetric;
} = {
    [EquipmentTypes.Flatbed]: ltColorMapFlatbed,
    [EquipmentTypes.Van]: ltColorMapVan,
    [EquipmentTypes.Reefer]: ltColorMapReefer,
};
